module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-50.3b078afa.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/home-front-service-lvl1-50.png
// module id = 3309
// module chunks = 11